module.exports = __webpack_public_path__ + "img/step_1.f645c568.png";